'use strict';

class ProductList {
  constructor(productService, reportService) {
    this.productService = productService;
    this.reportService = reportService;
  }

  $onInit() {
    this.products = {};

    // sorting
    this.predicate = 'code';
    this.reverse = false;
    this.order = (predicate) => {
      this.reverse = this.predicate === predicate ? !this.reverse : false;
      this.predicate = predicate;
    };

    this.load();
  }

  load() {
    this.productService.list()
      .then((resp) => {
        this.products = resp.data;
      });
  }

  export() {
    this.reportService.availableColumns('products')
      .then((resp) => {
        if (resp && resp.data) {
          let params = {
            format: 'XLS',
            columns: `${resp.data.map(data => data.key).join(',')}`
          };

          this.reportService.download('products', params);
        }
      });
  }
}

ProductList.$inject = ['productService', 'reportService'];

const productList = {
  controller: ProductList,
  template: `
    <div class="row">
      <div class="large-6 columns">
        <h2>Produktliste</h2>
      </div>

      <div class="large-6 columns right-align">
        <a href="#/produkt/nytt" role="button" class="button secondary"><i class="fa fa-plus"></i> Opprett nytt produkt</a>
        <a ng-show="$ctrl.products.items.length > 0" role="button" href ng-click="$ctrl.export()" class="button secondary"><i class="fa fa-file-excel-o"></i> Eksporter til Excel</a>
        <a href="#/produkt-lager" role="button" class="button secondary"><i class="fa fa-building"></i> Lagerbeholdning</a>
      </div>
    </div>

    <div class="row">
      <div class="large-6 columns">
        <p class="lead" ng-pluralize count="$ctrl.products.total" when="{'0': 'Ingen produkter', '1': '1 produkt', 'other': '{{ $ctrl.products.total }} produkter'}"></p>
      </div>

      <div class="large-6 columns search-input" ng-show="$ctrl.products.items.length > 1">
        <i class="fa fa-search"></i>
        <input type="search" ng-model="$ctrl.q" placeholder="Filtrer">
      </div>
    </div>

    <div class="row">
      <div class="large-12 columns">
        <table ng-if="$ctrl.products.items.length">
          <thead>
            <tr>
              <th ng-click="$ctrl.order('code')" ng-class="{ sortorder: $ctrl.predicate === 'code', reverse: $ctrl.reverse }">Produktnummer</th>
              <th>Beskrivelse</th>
              <th class="right-align" ng-click="$ctrl.order('unitPrice')" ng-class="{ sortorder: $ctrl.predicate === 'unitPrice', reverse: $ctrl.reverse }">Utsalgspris</th>
              <th ng-click="$ctrl.order('taxRate')" ng-class="{ sortorder: $ctrl.predicate === 'taxRate', reverse: $ctrl.reverse }">MVA</th>
              <th ng-click="$ctrl.order('quantity')" ng-class="{ sortorder: $ctrl.predicate === 'quantity', reverse: $ctrl.reverse }">Antall</th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="product in $ctrl.products.items | filter:$ctrl.q | orderBy:$ctrl.predicate:$ctrl.reverse track by product.number">
              <td>
                <a href="#/produkt/{{ product.number }}">{{ product.code }}</a>
              </td>
              <td>{{ product.description }}</td>
              <td class="right-align">{{ product.unitPrice | crowns }}</td>
              <td>{{ product.taxRate + '%' }}</td>
              <td>{{ product.quantity }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  `
};

angular
  .module('SendRegning')
  .component('productList', productList)
  .config(($routeProvider) => {
    $routeProvider
      .when('/produkt', {
        title: 'Produktliste',
        template: '<product-list />',
        secure: true
      });
  });
